import * as _ from 'lodash';
import { DropdownOption } from '../../definitions/formItem/ElementConfig';
var RelatedCollection = /** @class */ (function () {
    function RelatedCollection(obj, id) {
        if (id) {
            this.id = id;
        }
        if (obj.position) {
            this.position = obj.position;
        }
        console.log(obj);
        this.related_id = _.get(obj, 'related_id', _.get(obj, 'product'));
        // used only for formatting to dropdown option so it can be loaded in the control instantly 
        this.product_formatted = obj.related_name && obj.related_id ? new DropdownOption({
            label: _.get(obj, 'related_name'),
            value: _.get(obj, 'related_id'),
        }) : null;
    }
    Object.defineProperty(RelatedCollection.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RelatedCollection.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RelatedCollection.prototype, "Product", {
        get: function () {
            return this.related_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RelatedCollection.prototype, "ProductFormatted", {
        get: function () {
            return this.product_formatted;
        },
        enumerable: false,
        configurable: true
    });
    return RelatedCollection;
}());
export { RelatedCollection };
export function createRelatedCollection(obj, id) {
    return new RelatedCollection(obj, id);
}
export function createRelatedCollections(rawRelatedCollections) {
    var relatedCollections = [];
    var rawRelatedCollectionsData = rawRelatedCollections.data;
    for (var _i = 0, rawRelatedCollectionsData_1 = rawRelatedCollectionsData; _i < rawRelatedCollectionsData_1.length; _i++) {
        var rawRelatedCollection = rawRelatedCollectionsData_1[_i];
        var relatedCollection = createRelatedCollection(rawRelatedCollection.attributes, rawRelatedCollection.id);
        relatedCollections.push(relatedCollection);
    }
    return relatedCollections;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/relatedCollection/relatedCollection.ts
// module id = 127
// module chunks = 0